/**
 * /app/$tenantSlug/hr — old HR module overview. Navigation rebuild (wave 3,
 * 28 Oct 2026): HR people work now starts at Manage → People (/people),
 * whose tabs carry Documents, Assets and Imports; Onboarding and Exits are
 * their own Manage items. This route only redirects so old links and
 * bookmarks keep working. The sub-pages under /hr/* are unchanged.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { PEOPLE_PATH } from "@/lib/me-redirects";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: PEOPLE_PATH,
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
